import React, { useEffect, useRef } from 'react';
import { COMMENTS_CONFIG, DOM_IDS } from '../config';

interface CommentsWidgetProps {
  slug: string;
  apiUrl?: string;
  apiKey?: string;
}

const CommentsWidget: React.FC<CommentsWidgetProps> = ({slug}) => {
  const widgetRef = useRef<HTMLDivElement>(null);
  const scriptsLoadedRef = useRef(false);

  useEffect(() => {
    // Load CSS
    if (!document.querySelector(`link[href="${COMMENTS_CONFIG.CSS_PATH}"]`)) {
      const link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = COMMENTS_CONFIG.CSS_PATH;
      document.head.appendChild(link);
    }

    // Load JS script only once
    if (!scriptsLoadedRef.current && !document.querySelector(`script[src="${COMMENTS_CONFIG.JS_PATH}"]`)) {
      const script = document.createElement('script');
      script.src = COMMENTS_CONFIG.JS_PATH;
      script.async = true;
      
      script.onload = () => {
        scriptsLoadedRef.current = true;
        initializeComments();
      };
      
      document.body.appendChild(script);
    } else if (scriptsLoadedRef.current || window.CommentsSDK) {
      // Script already loaded, initialize directly
      initializeComments();
    }

    function initializeComments() {
      if (window.CommentsSDK && widgetRef.current) {
        window.CommentsSDK.init({
          containerId: DOM_IDS.COMMENTS_WIDGET,
          slug: slug,
          theme: document.documentElement.dataset.theme || 'light'
        });
      }
    }

    // Cleanup function
    return () => {
      // Optionally destroy the widget on unmount
      if (window.CommentsSDK && window.CommentsSDK.destroy) {
        window.CommentsSDK.destroy();
      }
    };
  }, [slug]);

  return (
    <div ref={widgetRef} id={DOM_IDS.COMMENTS_WIDGET} data-slug={slug} className="comments-section"></div>
  );
};

export default CommentsWidget;
